import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const CountdownTimer = ({ targetDate = new Date('2026-01-08T09:00:00-05:00'), label = "COMBINE OPENS" }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const target = new Date(targetDate);
      const difference = target - now;

      if (difference <= 0) {
        setIsExpired(true);
        return;
      }

      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      });
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (isExpired) {
    return (
      <div className="bg-gradient-to-r from-orange-600/20 to-orange-600/10 border border-orange-600/50 rounded-lg p-4 text-center">
        <div className="flex items-center justify-center gap-2 text-orange-500 font-black text-lg tracking-wider">
          <Clock className="w-5 h-5" />
          THE COMBINE IS NOW OPEN!
        </div>
      </div>
    );
  }

  const TimeBlock = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="bg-black border border-orange-600/50 rounded-lg px-4 py-3 min-w-[70px]">
        <span className="text-3xl md:text-4xl font-black text-white tabular-nums">
          {String(value).padStart(2, '0')}
        </span>
      </div>
      <span className="text-xs text-gray-500 mt-2 uppercase tracking-widest font-bold">{label}</span>
    </div>
  );

  return (
    <div className="bg-gradient-to-r from-gray-900 to-black border border-orange-600/30 rounded-xl p-6">
      <div className="text-center mb-4">
        <div className="flex items-center justify-center gap-2 text-orange-500 text-sm font-black tracking-widest mb-1">
          <Clock className="w-4 h-4" />
          {label}
        </div>
        <p className="text-gray-400 text-sm">Thursday, January 8th, 2026 • 9:00 AM EST</p>
      </div>
      
      <div className="flex justify-center items-center gap-3 md:gap-4">
        <TimeBlock value={timeLeft.days} label="Days" />
        <span className="text-2xl text-orange-600 font-bold mt-[-20px]">:</span>
        <TimeBlock value={timeLeft.hours} label="Hours" />
        <span className="text-2xl text-orange-600 font-bold mt-[-20px]">:</span>
        <TimeBlock value={timeLeft.minutes} label="Mins" />
        <span className="text-2xl text-orange-600 font-bold mt-[-20px]">:</span>
        <TimeBlock value={timeLeft.seconds} label="Secs" />
      </div>
      
      <div className="mt-4 text-center">
        <p className="text-orange-500 text-xs font-bold tracking-wider">THE FIRST MOVE IS THE PIVOT</p>
      </div>
    </div>
  );
};

export default CountdownTimer;
